import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  transition: transform 0s, opacity 0s;
  .cssActionContainerButtons {
    display: inline-flex;
    height: 100%;
    margin-left: ${pxToRem(10)};
    margin-bottom: ${pxToRem(8)};
  }
  .cssCombinatorDropdown {
    margin-bottom: ${pxToRem(10)};
  }
`;

export const QueryContainer = styled.div<{ isViewMode: boolean }>`
  &&&& {
    margin: 0;
    .cssDroppableContainer {
      background: ${({ isViewMode }) => (isViewMode ? '#eff0f0' : '#fff')};
      padding-bottom: 0;
      padding-top: 0;
      transition: background 0.2s;
      &.cssDraggingOver {
        background: #fffee2;
      }
    }

    ${({ isViewMode }) =>
      isViewMode
        ? `
        background: #eff0f0;
        border-radius: ${pxToRem(3)}; /** css file conversion */
        padding: ${pxToRem(10)} ${pxToRem(10)} ${pxToRem(5)} ${pxToRem(
          10,
        )}; /** css file conversion */
        margin: 0 0 0 -${pxToRem(20)}; /** css file conversion */
        `
        : ''}
  }
`;

export const SearchGroupContainer = styled.div<{ isViewMode: boolean }>`
  display: flex;
  ${({ isViewMode }) =>
    !isViewMode
      ? ''
      : `
    [data-role='search-group-container'] {
      margin-left: ${pxToRem(10)};
    }
`}
`;

export const Container = styled.div`
  flex: 1 1 auto;
  margin-bottom: ${pxToRem(10)};
  [data-role='connector'] + & {
    .cssCombinatorDropdown {
      display: inline-block;
      font-weight: 400;
      margin: 0;
      padding: ${pxToRem(5)} ${pxToRem(10)};
    }
    .cssActionContainerButtons {
      margin-bottom: 0;
    }
    ${QueryContainer} {
      margin: 0;
    }
  }
`;
